function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.filterMedia(); 
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  filterMedia() {
    $('[thumbnail-color]').hide();
    var selected_variant = this.currentVariant.featured_media.alt;
    var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
    if (selected_variant == selected_variant) {
    $(selected_attribute).show();
  }}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        
        const buyButtonPrice = document.getElementById(`price-buy-buttons-${this.dataset.section}`);
        const buyButtonPriceSource = html.getElementById(`price-buy-buttons-${this.dataset.originalSection || this.dataset.section}`);
        if (buyButtonPrice && buyButtonPriceSource) {
          buyButtonPrice.innerHTML = buyButtonPriceSource.innerHTML;
        }

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// New JS
document.addEventListener("DOMContentLoaded", function(event) { 
  let clearBtns = document.querySelectorAll(".clear-discount-btn");
  let applyBtns = document.querySelectorAll(".apply-discount-btn");
  let discountCodeErrors = document.querySelectorAll(".discount-code-error");
  let discountCodeWrappers = document.querySelectorAll(".applied-discount-code .applied-discount-code-wrapper");
  let discountCodeValues = document.querySelectorAll(".applied-discount-code .applied-discount-code-value");
  let discountCodeInputs = document.querySelectorAll(".discount-code-input");
  let totalCartSelectors = document.querySelectorAll(".totals__subtotal-value"); // Multiple Total Cart Selectors to update the total amount
  let authorization_token;

  // Restore discount code on page load
  if (localStorage.discountCode) {
    const storedCode = JSON.parse(localStorage.discountCode).code;
    discountCodeInputs.forEach((input, index) => {
      input.value = storedCode;
      applyDiscount(storedCode, index);
    });
  }

  applyBtns.forEach((applyBtn, index) => {
    applyBtn.addEventListener("click", function(e){
      e.preventDefault();
      console.log(`Applying discount for field ${index}`);
      applyDiscount(discountCodeInputs[index].value, index);
    });
  });

  clearBtns.forEach((clearBtn, index) => {
    clearBtn.addEventListener("click", function(e){
      e.preventDefault();
      console.log(`Clearing discount for field ${index}`);
      clearDiscount(index);
    });
  });

  function clearDiscount(index) {
    if (discountCodeValues[index]) {
      discountCodeValues[index].innerHTML = "";
      console.log(`Cleared discount value for field ${index}`);
    }
    if (discountCodeErrors[index]) {
      discountCodeErrors[index].innerHTML = "";
      console.log(`Cleared discount error for field ${index}`);
    }
    clearLocalStorage(index);
    fetch("/discount/CLEAR");
  }

  function clearLocalStorage(index) {
    if (discountCodeWrappers[index]) {
      discountCodeWrappers[index].style.display = "none";
      console.log(`Cleared local storage and hid wrapper for field ${index}`);
    }
    totalCartSelectors.forEach(selector => {
      if (localStorage.discountCode) {
        selector.innerHTML = JSON.parse(localStorage.discountCode).totalCart + " USD";
      }
    });
    localStorage.removeItem("discountCode");
  }

  function applyDiscount(code, index) {
    if (applyBtns[index]) {
      applyBtns[index].innerHTML = "Applying <div class='loader'></div>";
      applyBtns[index].style.pointerEvents = "none";
    }

    fetch("/payments/config", {"method": "GET"})
    .then(function(response) { return response.json() })
    .then(function(data) {
      const checkout_json_url = '/wallets/checkouts/';
      authorization_token = btoa(data.paymentInstruments.accessToken);
      fetch('/cart.js', {}).then(function(res){return res.json();})
      .then(function(data) {
        let body = {"checkout": { "country": Shopify.country,"discount_code": code,"line_items": data.items, 'presentment_currency': Shopify.currency.active } };
        fetch(checkout_json_url, {
          "headers": {
            "accept": "*/*", "cache-control": "no-cache",
            "authorization": "Basic " + authorization_token,
            "content-type": "application/json, text/javascript",
            "pragma": "no-cache", "sec-fetch-dest": "empty",
            "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
          },
          "referrerPolicy": "strict-origin-when-cross-origin",
          "method": "POST", "mode": "cors", "credentials": "include",
          "body": JSON.stringify(body)
        })
        .then(function(response) { return response.json() })
        .then(function(data) {
          console.log(`Received response for field ${index}`, data);
          if (data.checkout && data.checkout.applied_discounts.length > 0) {
            let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/";
            fetch(discountApplyUrl, {}).then(function(response) { return response.text(); });
            if (discountCodeWrappers[index]) {
              discountCodeWrappers[index].style.display = "inline";
              console.log(`Displayed discount wrapper for field ${index}`);
            }
            if (discountCodeErrors[index]) discountCodeErrors[index].innerHTML = "";
            if (discountCodeValues[index]) {
              discountCodeValues[index].innerHTML = data.checkout.applied_discounts[0].title + " (-" + data.checkout.applied_discounts[0].amount + ' ' + Shopify.currency.active + ")";
              console.log(`Updated discount value for field ${index}`);
            }
            let localStorageValue = {
              'code': code.trim(),
              'totalCart': data.checkout.total_line_items_price
            };
            localStorage.setItem("discountCode", JSON.stringify(localStorageValue));

            totalCartSelectors.forEach(selector => {
              selector.innerHTML = "$" + data.checkout.total_price + " USD" + "<span class='quick-compare_at_price'>$" + data.checkout.total_line_items_price + " USD</span>";
            });
          } else {
            if (discountCodeValues[index]) discountCodeValues[index].innerHTML = "";
            clearLocalStorage(index);
            if (discountCodeErrors[index]) discountCodeErrors[index].innerHTML = "Please Enter Valid Coupon Code.";
            console.log(`Error applying discount for field ${index}: Invalid code.`);
          }
        }).finally(function() {
          if (applyBtns[index]) {
            applyBtns[index].innerHTML = "Apply";
            applyBtns[index].style.pointerEvents = "all";
          }
        });
      });
    });
  }
});




$(document).ready(function(){
  $(document).on('click','.add-to-cart', function(e){
    e.preventDefault();
    var VarientId = $(this).closest('form').find('.variant__id').val();
    var Data = {
      id: VarientId,
      quantity: 1
    }
     $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: Data,
      success: function (product){  
        updateMainCart(); 
        mincart();
        updateCartTotal();
      },
      error: function(error){ 
        console.log("error");
      }
    });
  });
});
function channge_quantity_zero() {
    var cartItems = $('.gift_product_in_cart');
    var cartUpdates = {};
    cartItems.each(function() {
      var lineItemId = $(this).attr('data-item-id');
      cartUpdates[lineItemId] = 0;
    });
    var formData = {updates: cartUpdates};
    if (Object.keys(cartUpdates).length > 0) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(function(response) {
          mincart();
      })
      .catch(function(error) {
          console.error(error);
      });
    }
}

function updateMainCart() {
  $.ajax({
    type: 'GET',
    url: '/?section_id=main-cart-items', 
    dataType: 'html',
    success: function (updated_cart) {
      $('#main-cart-items').html($(updated_cart).find('#main-cart-items').html());
      updateCartTotal() 
    },
    error: function(){
      console.log("error updating main cart");
    }
  });
}


function mincart(){
  $.ajax({
    type: 'GET', 
    url: '/?section_id=cart-drawer',
    dataType: 'html', 
    success: function (updated_cart){ 
       $('.drawer__inner').html($(updated_cart).find('.drawer__inner').html()); 
       $('cart-drawer').removeClass('is-empty');
       $.getJSON('/cart.js', function(cart){ 
          if($("div").hasClass("cart-count-bubble"))
          {
            $('.cart-count-bubble span').html(cart.item_count);
          }else{
            $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' items</span></div>');
          }
        });
    },
    error: function(){   
      console.log("error");
    }
  });  
}

// Select the cart total element
const cartTotalElement = document.querySelector('.totals__subtotal-value'); // Adjust the selector if needed

// Update current_cart_total on each cart change
window.addEventListener('SCE:mutate', (event) => {
  // console.log('SCE:mutate event triggered'); // Check if the event listener is working
  updateCartTotal(); // Call the function to update the total
});

function updateCartTotal() {
  // Query current cart
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      // console.log('Cart data:', data); // Log the cart data for debugging
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: data.currency,
      });

      let rawvalue = data.total_price.toString();
      let rawvalue2 = rawvalue.slice(0, -2) + "." + rawvalue.slice(-2);
      const currentTotal = formatter.format(rawvalue2) + ' ' + data.currency;

      // Update the subtotal element
      const cartTotalElement = document.querySelector('#main-cart-footer .totals__subtotal-value'); // Ensure this selector is correct
      if (cartTotalElement) {
        cartTotalElement.textContent = currentTotal.replace('.', ',');
        // console.log('Cart total updated:', currentTotal); // Log the new total value
      } else {
        console.error('Cart total element not found in the DOM');
      }
    });
}


// For RangeBar Filter

function LoadRangeBar() {
  let rangeMin = 0;
  const range = document.querySelector(".range-selected");
  const rangeInput = document.querySelectorAll(".range-input input");
  const rangePrice = document.querySelectorAll(".range-price input");

  rangeInput.forEach((input) => {
    input.addEventListener("input", (e) => {
      let minRange = parseInt(rangeInput[0].value);
      let maxRange = parseInt(rangeInput[1].value);
      if (maxRange - minRange < rangeMin) {     
        if (e.target.className === "min") {
          rangeInput[0].value = maxRange - rangeMin;  
        } else {
          rangeInput[1].value = minRange + rangeMin;        
        }
      } else {
        $('#Filter-Price-GTE').val(minRange);
        $('#Filter-Price-LTE').val(maxRange);
        range.style.left = (minRange / rangeInput[0].max) * 100 + "%";
        range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + "%";
      }
    });
  });
}
$(window).on('load', function() {
  $('.range-input .min').val($('#Filter-Price-GTE').val());
  LoadRangeBar();
});



// WishList JS
$(document).ready(function(){
  // Check if LocalStorage is define
  let whishListIcon = $('.wishlist-icon');
  // let whishList_handles = [];
  let whishlistFound = localStorage.getItem('WishList');
  if(whishlistFound != null){
    localStorage.setItem("WishList",whishlistFound);
    whishList_handles = JSON.parse(whishlistFound);
  }
  else{
    whishList_handles = [];
  }
  // Adding Product to WishList
  for(item of whishListIcon){
    item.addEventListener('click',(event)=>{   
      let inList = whishList_handles.indexOf(event.target.closest('.collection_item').getAttribute('data-product-handle'));
      if(inList === -1){
        whishList_handles.push(event.target.closest('.collection_item').getAttribute('data-product-handle'));
        localStorage.setItem("WishList",JSON.stringify(whishList_handles));
        console.log(whishlistFound);
        updateCustomerWishlist();
        event.target.closest('.collection_item').querySelector('.wishlist-icon').classList.add("added-to-wishlist");
        CountWishListProduct();
      }else{
        let index = whishList_handles.indexOf(event.target.closest('.collection_item').getAttribute('data-product-handle'));
        whishList_handles.splice(index, 1);
        localStorage.setItem("WishList",JSON.stringify(whishList_handles));
        
        event.target.closest('.collection_item').querySelector('.wishlist-icon').classList.remove("added-to-wishlist");
        CountWishListProduct();
      }
    });
  }
  // Check Product in WishList or Not When load
  let whishList = localStorage.getItem('WishList');
  let jsonWhishlist = JSON.stringify(whishList);
  $('.collection_item').each(function(){
      let productHandle = $(this).attr('data-product-handle');
      if (jsonWhishlist.includes(productHandle)){
        $(this).find('.wishlist-icon').addClass('added-to-wishlist');
      }
  });
  // Function For Count WishList Product
  CountWishListProduct();
  function CountWishListProduct(){
    let checklist = localStorage.getItem('WishList');
    if(checklist != null){
        let CounProduct = 0;
        for(product of JSON.parse(checklist)){ 
          CounProduct = CounProduct + 1; 
        }
        if(CounProduct > 0)
        {
          $('.wishlist-count-bubble').show();
          $('.wishlist-count-bubble span').html(CounProduct);
          $('.wish-list-product-btn').removeClass('hidden');
        }else{
          $('.wishlist-count-bubble').hide();
          $('.wish-list-product-btn').addClass('hidden');
        }
    }else{
      $('.wishlist-count-bubble').hide();
      $('.wish-list-product-btn').addClass('hidden');
    }
  }

  // Print Product in Wishlist Page 
  // let checklist = localStorage.getItem('WishList');
  //     let ListItem = JSON.parse(checklist);


    function displayWishlistProducts(wishlistHandles) {
        for (let product of wishlistHandles) {
          // console.log(product);
            jQuery.getJSON(window.Shopify.routes.root + 'products/' + product + '.js', function(product) {
              let priceOnSaleClass = product.compare_at_price > product.price ? 'price--on-sale' : '';
              let WishListItems = `<li class="grid__item grid__item_relative collection_item" data-product-handle="${product.handle}">
                <div class="wishlist-product-image">
                  <a class="" href="${product.url}">
                    <img class="wishlist_product_image" src="${product.featured_image}" alt="${product.handle}" loading="lazy">
                  </a>
                </div>
                <div class="wishlist-card__information">
                  <h3 class="wishlist-product-title card__heading h5">
                    <a href="${product.url}" class="full-unstyled-link">${product.title}</a>
                  </h3>
                  <div class="wishlist-product-price">
                    <div class="price__sale_ ${priceOnSaleClass}">
                    <span class="price-item price-item--sale price-item--last">
                     ${Shopify.formatMoney(product.price, "${{amount}}")} 
                    </span>
                      <s class="price-item price-item--regular">
                      &nbsp;&nbsp;${Shopify.formatMoney(product.compare_at_price, "${{amount}}")}
                      </s>
                    </div>
                  </div>
                </div>
                <div class="wishlist-product-add-to-cart">
                  <button type="button" class="wishlist_product_remove">
                    <span>
                      <svg height="20px" width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
                        <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                        <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                      </svg>
                    </span>
                    <div class="loading-overlay__spinner hidden">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                    </div>
                  </button>
                  <product-form class="product-form" data-hide-errors="">
                    <div class="product-form__error-message-wrapper" role="alert" hidden="">
                      <span class="product-form__error-message"></span>
                    </div>
                    <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${product.variants[0].id}" class="wishlist-product-id">
                      <button id="ProductSubmitButton-template--18832536142145__featured_collection" type="submit" name="add" class="product-form__submit button button--full-width button--primary" aria-haspopup="dialog">
                      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:8px;">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M21.1056 6.86035L22.3656 15.2004C22.8756 18.8504 20.3656 22.1704 16.9656 22.2004H7.70559C4.36559 22.2004 1.82559 18.8504 2.36559 15.2004L3.62559 6.86035C3.92472 4.10272 6.19427 1.97767 8.96559 1.86035H15.7656C18.5369 1.97767 20.8065 4.10272 21.1056 6.86035ZM16.9956 20.6704C18.0693 20.6548 19.0821 20.1686 19.7656 19.3404C20.6823 18.2547 21.0803 16.8234 20.8556 15.4204L19.6256 7.08035C19.45 5.04464 17.8055 3.44708 15.7656 3.33035H8.96559C6.92565 3.44708 5.28123 5.04464 5.10559 7.08035L3.87559 15.4204C3.6509 16.8234 4.04889 18.2547 4.96559 19.3404C5.6491 20.1686 6.66186 20.6548 7.73559 20.6704H16.9956Z" fill="currentColor"/>
                      <path d="M15.5156 7.06035C15.1014 7.06035 14.7656 7.39614 14.7656 7.81035C14.7656 9.13583 13.6911 10.2104 12.3656 10.2104C11.0401 10.2104 9.96559 9.13583 9.96559 7.81035C9.96559 7.39614 9.6298 7.06035 9.21559 7.06035C8.80138 7.06035 8.46559 7.39614 8.46559 7.81035C8.46559 9.20369 9.20893 10.4912 10.4156 11.1879C11.6223 11.8845 13.1089 11.8845 14.3156 11.1879C15.5223 10.4912 16.2656 9.20369 16.2656 7.81035C16.2602 7.39839 15.9276 7.06574 15.5156 7.06035Z" fill="currentColor"/>
                      </svg>
                        <span>Add to cart
                        </span>
                        <div class="loading-overlay__spinner hidden">
                          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                      </button>
                    </form>
                  </product-form>
                </div>
              </li>`;
              $('.wishlist-main-products .wishlist-product-grid').append(WishListItems);
          });  
      }
    }

  //   if (window.Shopify && window.Shopify.customer) {
  //     // If logged in, use the wishlist from the customer's metafield
  //     if (wishlistFromMetafields && wishlistFromMetafields.length > 0) {
  //         displayWishlistProducts(wishlistFromMetafields);
  //     } else {
  //         // If the metafield is empty or not set, fall back to localStorage
  //         let checklist = localStorage.getItem('WishList');
  //         if (checklist) {
  //             let wishlistHandles = JSON.parse(checklist);
  //             displayWishlistProducts(wishlistHandles);
  //         }
  //     }
  // } else {
  //     // If not logged in, fetch the wishlist from localStorage
  //     let checklist = localStorage.getItem('WishList');
  //     if (checklist) {
  //         let wishlistHandles = JSON.parse(checklist);
  //         displayWishlistProducts(wishlistHandles);
  //     }
  // }

  if (window.customerWishlist && window.customerWishlist.length > 0) {
    displayWishlistProducts(window.customerWishlist);
} else {
    // If not, fetch the wishlist from localStorage
    let checklist = localStorage.getItem('WishList');
    if (checklist) {
        let wishlistHandles = JSON.parse(checklist);
        displayWishlistProducts(wishlistHandles);
    }
}


 
  // Remove from WishList from WishList page

  $(document).on('click','.wishlist_product_remove', function(){
    $(this).addClass('loading');
    $(this).find('.loading-overlay__spinner').removeClass('hidden');
    let __this = $(this);
    setTimeout(function(){
      let productHandle = __this.closest('.collection_item').attr("data-product-handle");
      let whishlistStrigify = localStorage.getItem('WishList');
      let jsonwishList = JSON.parse(whishlistStrigify);
      let index = jsonwishList.indexOf(productHandle);
      if (index !== -1) jsonwishList.splice(index, 1);
      if (index !== -1) __this.closest('.collection_item').remove();
      localStorage.setItem("WishList",JSON.stringify(jsonwishList));
      updateCustomerWishlist();
      CountWishListProduct();
      $('.wishlist_product_remove').removeClass('loading');
      $('.wishlist_product_remove').find('.loading-overlay__spinner').addClass('hidden');
    },1000);
  });
  // Remove All Product from Wishlist
  $(document).on('click','.remove_all_from_wishlist', function(){
    $(this).addClass('loading');
    $(this).find('.loading-overlay__spinner').removeClass('hidden');
    setTimeout(function(){
      localStorage.removeItem('WishList');
      // console.log(localStorage.getItem('WishList'));
      $('.wishlist-product-grid .collection_item').remove();s
      CountWishListProduct();
      $('.remove_all_from_wishlist').removeClass('loading');
      $('.remove_all_from_wishlist').find('.loading-overlay__spinner').addClass('hidden');
    },1000);
  });
  
  // Add All WishList Product To Cart
  $(document).on("click",".add_all_to_cart",function(e){
    e.preventDefault();
    $(this).addClass('loading');
    $(this).find('.loading-overlay__spinner').removeClass('hidden');
    let WishlistProducts = [];
    $('.wishlist-product-grid .collection_item').each(function(){
        var variant_id = $(this).find('product-form .wishlist-product-id').val();
        var ProductDATA = {
    	    id: parseInt(variant_id),
    	    quantity: parseInt(1)
  	    }
        WishlistProducts.push(ProductDATA);
    }); 
    let formData = {items:WishlistProducts};
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        // localStorage.removeItem('WishList');
        // $('.wishlist-product-grid .collection_item').remove();
        // window.location.href = "/cart";
        mincart();
        setTimeout(function(){
          var cartIcon = document.querySelector('.header__icon--cart');
          var clickEvent = new Event('click');
          cartIcon.dispatchEvent(clickEvent);
        },500);
        $('.add_all_to_cart').removeClass('loading');
        $('.add_all_to_cart').find('.loading-overlay__spinner').addClass('hidden');
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });
  // Add Product To Wishlist In Product Page
  $(document).on("click",".product_page_add_to_wishlist_button",function(e){
    e.preventDefault();
    let whishlistFound = localStorage.getItem('WishList');
    if(whishlistFound != null){
      localStorage.setItem("WishList",whishlistFound);
      whishList_handles = JSON.parse(whishlistFound);
    }
    else{
      whishList_handles = [];
    }
    let inList = whishList_handles.indexOf($('.product_page_add_to_wishlist_button').attr('data-product-handle'));
      if(inList === -1){
        whishList_handles.push($('.product_page_add_to_wishlist_button').attr('data-product-handle'));
        localStorage.setItem("WishList",JSON.stringify(whishList_handles));
        $('.product_page_add_to_wishlist_button').addClass('added-to-wishlist');
        CountWishListProduct();
      }else{
        let index = whishList_handles.indexOf($('.product_page_add_to_wishlist_button').attr('data-product-handle'));
        whishList_handles.splice(index, 1);
        localStorage.setItem("WishList",JSON.stringify(whishList_handles));
        $('.product_page_add_to_wishlist_button').removeClass('added-to-wishlist');
        CountWishListProduct();
      }
      // To check product in wishlist in collection level
      setTimeout(function(){
        let whishList = localStorage.getItem('WishList');
        let jsonWhishlist = JSON.stringify(whishList);
        $('.collection_item').each(function(){
          let productHandle = $(this).attr('data-product-handle');
          if (jsonWhishlist.includes(productHandle)){
            $(this).find('.wishlist-icon').addClass('added-to-wishlist');
          }else{
            $(this).find('.wishlist-icon').removeClass('added-to-wishlist');
          }
        });
      },500);
  });
  // Check Product In WishList or Not In Product Page Load
  let ProductHandle = $('.product_page_add_to_wishlist_button').attr('data-product-handle');
  if (jsonWhishlist.includes(ProductHandle)){
    $('.product_page_add_to_wishlist_button').addClass('added-to-wishlist');
  }
});

function updateCustomerWishlist() {
  let wishlist = localStorage.getItem('WishList');
  if (!wishlist) {
      console.error("No wishlist found in localStorage.");
      return;
  }

  wishlist = JSON.parse(wishlist);

  if (!window.customerId) {
      console.error("User not logged in.");
      return;
  }

  fetch('https://shopify-cust-app.vercel.app/api/update-wishlist', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      mode: 'cors',
      body: JSON.stringify({
          customer_id: window.customerId,
          wishlist: wishlist
      })
  })
  .then(response => response.json())
  .then(data => {
      if (data.error) {
          console.error("Error updating wishlist:", data.error);
      } else {
          console.log("Wishlist updated successfully:", data.customer);
      }
  })
  .catch(error => {
      console.error("Error updating wishlist:", error);
  });
}





class ShareBlock extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.fb-share').href = `https://www.facebook.com/sharer/sharer.php?u=${window.location}`;
    this.querySelector('.tw-share').href = `https://twitter.com/intent/tweet?text=${window.location}`;
    this.querySelector('.copy-to-cb').addEventListener('click', () => {
      navigator.clipboard.writeText(window.location);
    })
  }
}

customElements.define('share-block', ShareBlock);



$(window).scroll(function() {
  if ( $(window).scrollTop() >= 1200 ) {
      $('.sticky-button').css('position', 'fixed');
      $('.sticky-button').css('opacity', '1');
      $('.sticky-button').css('display', 'flex');

  } else {
      $('.sticky-button').attr('style', '');
      $('.sticky-button').css('display', 'none');
  }
});


document.querySelectorAll('.copy-button').forEach(button => {
  button.addEventListener('click', function() {
      var input = this.previousElementSibling;
      input.select();
      input.setSelectionRange(0, 99999); // For mobile devices

      document.execCommand('copy');

      var tooltip = this.nextElementSibling;
      tooltip.classList.add('show');
      setTimeout(() => {
          tooltip.classList.remove('show');
      }, 2000);
  });
});
